import React from 'react';

import Article from './Article/Article';

import { ReactComponent as LinkArrow } from 'assets/icons/link_arrow.svg';

import styles from './Articles.module.scss';

const Articles = ({ data, selectedCategory, setSelectedCategory, loadMoreData, limit, noMoreData, showRegisterModal }) => {
	const items = selectedCategory === data.target_type ? data.items : data.items.slice(0, 3);

	return (
		<div className={[styles.articles, data ? styles.animate : null].join(' ')}>
			<div className={styles.header}>
				<div className={styles.header_title}>
					<h2>{data && data.item_count} {data.item_count !== 1 ? 'Articles' : 'Article'}</h2>
					{selectedCategory !== data.target_type &&
						<span onClick={(e) => setSelectedCategory(data.target_type, e)} id="open">
							View all <LinkArrow />
						</span>
					}
				</div>
			</div>
			<div className={styles.content}>
				{items && items.map(el => {
					return (
						<Article
							key={el.id}
							data={el}
							showModal={showRegisterModal}
						/>
					);
				})}
			</div>
			{selectedCategory === data.target_type && !(noMoreData || (items && items.length >= data.item_count)) &&
				<button
					type="button"
					onClick={loadMoreData}
					className={styles.more_btn}
					disabled={noMoreData || (items && items.length >= data.item_count)}
				>
					Show me more
				</button>
			}
		</div>
	);
};

export default Articles;
